import Impact from '../../../components/impact/Impact.jsx';
import InlineComponent from './inlineComponent.jsx';

module.exports = class impact extends InlineComponent {
  define() {
    this.component = Impact;
    this.data = {
      impact: this.element.data('impact'),
    };
  }
};
